<template>
  <div>
    <download-excel
      style="display: inline-block"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="已支付图表.xls"
    >
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0', display: 'inline-block' }"
      >
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, record">
        <a
          href="javascript:;"
          v-on:click.prevent="
            topage(`/home/payForTheOrderDetailsTwo?orderNo=${record.orderNo}`)
          "
          >订单详情</a
        >
<!--        v-if="record.statusShop == 1510"-->
        <span

          style="margin-left: 10px;color: red;cursor: pointer;"
          @click="refund(record)"
          >退款</span
        >
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  payForOrderList,
  payForOrderListSeach,
  payOrderRefund
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: " 订单编号",
    dataIndex: "orderNo",
    align: "center",
    sorter: true
  },
  {
    title: "订单类型",
    dataIndex: "orderType",
    align: "center"
  },
  {
    title: "订单数量",
    dataIndex: "goodsNum",
    align: "center"
  },
  {
    title: "订单金额",
    dataIndex: "pricePay",
    sorter: true,
    align: "center"
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    sorter: true
  },
  {
    title: "用户ID",
    dataIndex: "userUid",
    align: "center",
    sorter: true
  },
  {
    title: "支付时间",
    dataIndex: "createTime",
    align: "center",
    sorter: true
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        订单编号: "orderNo",
        商品类型: "shopRunTypeStr",
        支付金额: "pricePay",
        商品封面: "avatar",
        所属门店: "shopName",
        用户ID: "userUid",
        订单状态: "statusShopStr",
        下单时间: "createTime"
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      visible: false
    };
  },
  mounted() {
    this.getAlreadyPayData();
  },
  props: ["formInline"],
  methods: {
    async startDownload() {
      this.loading = true;
      await payForOrderListSeach(
        10000,
        1,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then(res => {
        this.data1 = res.data;
        this.loading = false;
      });
      return this.data1;
    },
    topage(routerpath, record) {
      console.log(record);
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      // payForOrderList(10, this.pagination.current, 1401).then((res) => {
      //   this.data = res.data;
      //   console.log(res);
      //   this.loading = false;
      // });
      payForOrderListSeach(
        this.formInline.limit,
        this.pagination.current,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then(res => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    getAlreadyPayData() {
      payForOrderList(10, 1).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
      });
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    query() {
      this.pagination.current = 1;
      this.loading = true;
      payForOrderListSeach(
        this.formInline.limit,
        1,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then(res => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    refund(record) {
      let that = this;
      that.$confirm({
        title: "提示",
        content: "是否退款",
        onOk() {
          let params = {
            fun: "Refund",
            uid: record.userUid,
            orderId: record.orderNo,
            refundAmount: record.pricePay
          };
          console.log("refund params: ", params);
          return new Promise((resolve, reject) => {
            payOrderRefund(params).then(res => {
              console.log("refund res: ", res);
              if (res.success) {
                message.success("退款成功");
                that.handleTableChange(that.pagination);
                setTimeout(resolve, 1000);
              } else {
                message.error(res.info);
              }
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {}
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/orderManagement/payForTheOrderTwo/payForTheOrderContentTwo.vue